function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import analytics from '../../lib/shared/analytics';
import config from '../../lib/shared/config';
import Log from '../../lib/client/setup/log';
import React from 'react';
import URITemplate from '../../lib/shared/uritemplate';
import xhrp from '../../lib/client/xhr-promise';
import vaultUtil from '../../lib/client/vault-util';
import '../../scss/setup/deploy/_validator.scss';
var brokerUri = new URITemplate("{+context}/broker/{service_id}/{verb}");
var _ValidatorController = function ValidatorController(args, component) {
  _ValidatorController.prototype.validatorCount++;
  // Adding counter to validator id so we can support more than 1 instance of a validator with a given URL on the page
  this.id = (args.url || args.capability.capabilityId) + "#" + this.validatorCount;
  this.logger = Log.getLogger("ValidatorController " + this.id);
  this.capability = args.capability;
  this.schema = args.capability.schema;
  this.getLastModification = args.getLastModification;
  this.onScheduleWork = args.onScheduleWork;
  this.isFormValid = args.isFormValid || Function.prototype;
  this.overrideFormValidity = args.overrideFormValidity || Function.prototype;
  this.component = component;
  this.setCfTarget(args.cfTarget);
  this.parameters = args.capability.parameters;
  this.capabilities = args.capabilities;
  var urlString = args.url;
  var VALIDATOR_URL = config.VALIDATOR_URL;
  if (VALIDATOR_URL) {
    urlString = VALIDATOR_URL + "/" + (args.url.charAt(0) === "/" ? args.url.substr(1) : args.url);
  } else if (args.url && args.url.indexOf('https://') !== 0) {
    urlString = location.protocol + "//" + location.host + "/" + (args.url.charAt(0) === "/" ? args.url.substr(1) : args.url);
  }
  this.formValidator = urlString;
  this.capabilityController = args.controller;
  this.capabilityController.addValidator(this);
  this.capabilityController.onValidatorEvent("load", {
    type: "start",
    source: this
  });
  this.populatePending = false;
  this.initialLoad = true;
  this.toolchainId = args.toolchainId;
};
_ValidatorController.prototype = {
  validatorCount: 0,
  // Make an authenticate/populate/validate call to the broker
  callBroker: function callBroker(verb, body) {
    var handler = this.handleAjaxResponse.bind(this, verb);
    var uri = brokerUri.expand({
      context: config.CONTEXT_PATH,
      service_id: this.getServiceId(),
      verb: verb
    });
    // Pass along any query params
    var href = window && window.location && window.location.href;
    if (href) {
      uri = href.split('?')[1] ? uri + '?' + href.split('?')[1] : uri;
    }
    xhrp(uri, {
      method: "POST",
      dataType: "json",
      body: body
    }).then(handler, handler);
  },
  validatorRecursiveEnableSpinners: function validatorRecursiveEnableSpinners(root, level) {
    // Guard against infinite recursion
    if (!level) {
      level = 0;
    } else if (level > 10) {
      return;
    }

    // Process the properties
    if (this.schema && this.schema.properties) {
      var properties = this.schema.properties;
      for (var key in properties) {
        if (properties.hasOwnProperty(key)) {
          var property = properties[key];
          if (property && property.validator && property.validator.params) {
            if (property.validator.params.indexOf && property.validator.params.indexOf(root) !== -1 && property.spinner !== "start") {
              property.spinner = "start";
              this.validatorRecursiveEnableSpinners(key, level + 1);
            }
          }
        }
      }
    }
  },
  populate: function populate(changeSummary) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // TODO skip populate if broker doesn't provide this method
    this.updateSchema();
    var properties = this.schema.properties;
    this.lastChangeSummary = changeSummary;
    this.populatePending = true;
    Object.keys(this.parameters).forEach(function (p) {
      if (p === "__lastTimestamp") return;
      if (typeof properties[p] === "undefined") return;
      if (typeof this.parameters[p] === "undefined") return;
      if ((this.initialLoad || options.needsRepopulateInitital) && _typeof(properties[p]) === "object") {
        // Start the spinners on all properties on initial load, excluding validator-v1-loaded, -state
        properties[p].spinner = "start";
      }
      properties[p].value = this.parameters[p];
      if (changeSummary && changeSummary[p]) {
        properties[p].changed = true;
        // Start the spinners on the changed property and any dependants
        properties[p].spinner = "start";
        this.validatorRecursiveEnableSpinners(p);
      }
    }.bind(this));
    properties.__lastTimestamp = this.lastTimestamp = Date.now();
    var templateServices = this.capabilities && this.capabilities.templateData && this.capabilities.templateData.services;
    var serviceInstance = this.capability.serviceInstance;
    var _ref = typeof serviceInstance !== 'undefined' && serviceInstance || {},
      instanceId = _ref.instance_id;
    var data = {
      properties: properties,
      userInfo: this.component.props.userInfo,
      service_id: this.getServiceId() || "",
      cf: this.cfTarget,
      type: "populate",
      form: this.schema.form,
      instance_id: instanceId,
      state: this.capability.serviceInstance ? this.capability.serviceInstance.status.state : "create",
      vaultIntegrations: vaultUtil.getVaultIntegrations(templateServices),
      toolchainId: this.toolchainId
    };
    delete this.capabilityController.authorizationURI;
    this.callBroker("populate", data);
    this.capabilityController.onValidatorEvent("populate", {
      type: "start",
      source: this
    });
  },
  validate: function validate() {
    // TODO skip validate if broker doesn't provide this method
    if (this.populatePending) {
      this.logger.debug("Skip requested validate: populate has not completed");
      return;
    }
    this.updateSchema();
    var properties = this.schema.properties;
    var templateServices = this.capabilities && this.capabilities.templateData && this.capabilities.templateData.services;
    var serviceInstance = this.capability.serviceInstance;
    var _ref2 = typeof serviceInstance !== 'undefined' && serviceInstance || {},
      instanceId = _ref2.instance_id;
    var data = {
      userInfo: this.component.props.userInfo,
      validationType: "create",
      properties: properties,
      service_id: this.getServiceId() || "",
      type: "validate",
      vaultIntegrations: vaultUtil.getVaultIntegrations(templateServices),
      toolchainId: this.toolchainId,
      instance_id: instanceId
    };
    this.callBroker("validate", data);
    this.capabilityController.onValidatorEvent("validate", {
      type: "start",
      source: this
    });
  },
  authenticate: function authenticate() {
    // TODO skip authenticate if broker doesn't provide this method
    this.updateSchema();
    var templateServices = this.capabilities && this.capabilities.templateData && this.capabilities.templateData.services;
    var data = {
      userInfo: this.component.props.userInfo,
      service_id: this.getServiceId() || "",
      type: "authenticate",
      vaultIntegrations: vaultUtil.getVaultIntegrations(templateServices),
      toolchainId: this.toolchainId
    };
    this.callBroker("authenticate", data);
    this.capabilityController.onValidatorEvent("authenticate", {
      type: "start",
      source: this
    });
  },
  getParamDef: function getParamDef(theObject, property, key) {
    var paramDef = null;
    if (theObject instanceof Array) {
      for (var i = 0; i < theObject.length; i++) {
        paramDef = this.getParamDef(theObject[i], property, key);
        if (paramDef) {
          break;
        }
      }
    } else if (theObject instanceof Object) {
      for (var prop in theObject) {
        if (prop === 'key' && theObject[prop] === key && theObject.enum) {
          return Object.assign({}, property || {}, theObject);
        }
        if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
          paramDef = this.getParamDef(theObject[prop], property, key);
          if (paramDef) {
            break;
          }
        }
      }
    }
    return paramDef;
  },
  // Injects latest values from `this.parameters` (which is modified by the templating engine) into this.schema.properties.
  // This is needed to provide the most up-to-date field values in the validator payload.
  // TODO stop mutating the schema in this file
  updateSchema: function updateSchema() {
    var _this = this;
    var params = this.parameters;
    Object.keys(params).forEach(function (paramName) {
      var value = params[paramName];
      if (typeof value !== "undefined") {
        var obj = _this.schema.properties[paramName];
        if (obj && _typeof(obj) === "object") {
          obj.value = value;
        } else {
          _this.schema.properties[paramName] = {
            value: value
          };
        }
      }
    });
  },
  checkAndSetFormValidity: function checkAndSetFormValidity(key, value) {
    var properties = this.schema.properties;
    var isFormValid = true;
    Object.keys(properties).forEach(function (prop) {
      var prevProp = properties[prop];
      if (key === prop && prevProp.validationMessage && value) {
        delete properties[prop].validationMessage;
      } else if (prevProp.required && prevProp.validationMessage) {
        isFormValid = false;
      }
    }.bind(this));
    this.logger.debug("Before running populate/validate, is form valid? " + (isFormValid ? "yes" : "NO"));
    this.setFormValid(isFormValid);
  },
  setValidityOverride: function setValidityOverride(valid) {
    if (this.capability.overrideFormValidity !== valid) {
      this.capability.overrideFormValidity = valid;
      this.overrideFormValidity(valid);
      this.setFormValid(!valid);
    }
  },
  setFormValid: function setFormValid(value) {
    this.capability.isFormValid = this.capability.overrideFormValidity ? false : value;
    this.isFormValid(this.capability.overrideFormValidity ? false : value);
  },
  getFormValid: function getFormValid() {
    return this.capability.isFormValid;
  },
  setCfTarget: function setCfTarget(target) {
    this.cfTarget = target;
  },
  // @param xhrResult {body, xhr} (may be an error or a success)
  handleAjaxResponse: function handleAjaxResponse(verb, xhrResult) {
    var body = xhrResult.body;
    var payload = body && body[verb];
    if (isErrorResponse(xhrResult) || isUnauthorizedResponse(xhrResult) && !(payload !== null && payload !== void 0 && payload.authorizationURI)) {
      var _xhrResult$xhr, _xhrResult$xhr2;
      // note, if 401 and git broker returned authorizationURI, will show Authorize button. Other 401 is a problem
      this.logger.error("Returned an error (status " + (xhrResult === null || xhrResult === void 0 || (_xhrResult$xhr = xhrResult.xhr) === null || _xhrResult$xhr === void 0 ? void 0 : _xhrResult$xhr.status) + ") :", JSON.stringify(body));
      var errorMessage = payload && (payload.description || JSON.stringify(payload)) || body && JSON.stringify(body) || (xhrResult === null || xhrResult === void 0 || (_xhrResult$xhr2 = xhrResult.xhr) === null || _xhrResult$xhr2 === void 0 ? void 0 : _xhrResult$xhr2.status) && "HTTP ".concat(xhrResult.xhr.status) || "error";
      this.capabilityController.formError = errorMessage;
      this.setFormValid(false);
      // don't attempt to handle this event
    } else {
      if (!payload) {
        this.logger.error("Returned a bogus message:", JSON.stringify(body));
        return;
      }
      var handler = this.ajaxHandlers[verb];
      if (typeof handler !== "function") {
        // don't know
        return;
      }
      handler.call(this, xhrResult.xhr, body);
    }
    this.capabilityController.onValidatorEvent(verb, {
      type: "end",
      source: this
    });
  },
  handlePostMessage: function handlePostMessage(event) {
    // Only listen for messages from the oauth popup
    if (!this.capabilityController.popup || event.source !== this.capabilityController.popup) {
      return;
    }
    if (!event.data.request || !event.data.response) {
      this.logger.error("Returned a bogus message:", JSON.stringify(event.data));
      return;
    }
    if (isErrorResponse(event.data.response)) {
      this.logger.error("Returned an error:", JSON.stringify(event.data));
      var errorMessage = event.data.response.description || JSON.stringify(event.data.response);
      this.capabilityController.formError = errorMessage;
      this.setFormValid(false);
      // don't attempt to handle this event
    } else if (event.data.request === "oauth-return") {
      this.handleOauthReturn(event);
    } else {
      // don't know
      return;
    }
    this.capabilityController.onValidatorEvent(event.data.request, {
      type: "end",
      source: this
    });
  },
  ajaxHandlers: {
    "authenticate": function authenticate(xhr, body) {
      if (xhr.status === 401) {
        analytics.track("auth.form.not-authenticated", {
          label: this.getServiceId()
        });
        var authButton;
        body.authenticate.some(function (e) {
          if (e.href) {
            authButton = e;
            return true;
          }
        });
        this.capabilityController.authorizationURI = authButton.href;
        this.setFormValid(false); // Not valid -- needs auth
      } else {
        //should be bound by ok code or something
        analytics.track("auth.form.authenticated", {
          label: this.getServiceId()
        });
        this.setFormValid(true);
        this.logger.debug("Got 'authenticate'. Call populate");
        this.scheduleWork("populate");
      }
    },
    "populate": function populate(xhr, body) {
      var ms;
      if ((ms = this.getResponseStaleness(body.populate)) > 0) {
        this.logger.debug("Got 'populate': stale by " + ms + "ms. schedule populate");
        this.scheduleWork("populate");
        return;
      }
      this.populatePending = false;
      var authProperties = {};
      if (body.populate.body.authorizationURI) {
        authProperties.statusCode = 401;
        this.capabilityController.authorizationURI = body.populate.body.authorizationURI;
        authProperties.authorizationURI = body.populate.body.authorizationURI;
        delete body.populate.body.authorizationURI;
      }
      if (body.populate.body.form) {
        this.schema.form = body.populate.body.form;
        this.schema.populateComplete = true;
        delete body.populate.body.form;
      }
      var properties = this.schema.properties = body.populate.body;
      var changeSummary = Object.create(null);
      Object.keys(properties).forEach(function (prop) {
        var oldValue = this.parameters[prop];
        var newValue = valueOf(properties[prop]);
        if (properties[prop].type && properties[prop].type === "boolean") {
          if (newValue === undefined && oldValue === false) {
            newValue = false;
          }
        }
        if (typeof newValue !== "undefined" && oldValue !== newValue) {
          changeSummary[prop] = Change(oldValue !== newValue);
        }
        this.parameters[prop] = newValue;
      }.bind(this));
      if (authProperties && authProperties.statusCode === 401) {
        analytics.track("auth.form.not-authenticated", {
          label: this.getServiceId()
        });
        this.capabilityController.authorizationURI = authProperties.authorizationURI;
        this.setFormValid(false); // Not valid -- needs auth
      } else {
        this.logger.debug("Got 'populate'. Schedule validate");
        this.capabilityController.updateRefs(changeSummary);
        this.scheduleWork("validate");
      }
    },
    "validate": function validate(xhr, body) {
      var properties = this.schema.properties = body.validate.body;
      var changeSummary = Object.create(null);
      var isFormValid = true;
      Object.keys(properties).forEach(function (prop) {
        var oldValue = this.parameters[prop];
        var newProp = properties[prop];
        var newValue = valueOf(newProp);
        var propsEnum = properties[prop].enum;
        var propDef = this.getParamDef(this.schema.form, properties[prop], prop);
        var setEnum = false;
        if ((newValue === undefined || newValue === '') && propsEnum && propsEnum.length > 0) {
          if (propDef && propDef.readonly && propDef.readonly === true) {
            if (_typeof(propsEnum[0]) === "object") {
              newValue = propsEnum[0].value;
              setEnum = true;
            } else {
              newValue = propsEnum[0];
              setEnum = true;
            }
          } else if (propDef === null) {
            if (_typeof(propsEnum[0]) === "object") {
              newValue = propsEnum[0].value;
              setEnum = true;
            } else {
              newValue = propsEnum[0];
              setEnum = true;
            }
          }
        }
        var changed = oldValue !== newValue || newProp.validationMessage || newProp.changed;
        if (typeof newValue !== "undefined" && changed) {
          //only in case of some integrations, validate function, returns the new values in case of enums, that need to be set
          if (setEnum) {
            this.parameters[prop] = newValue;
          }
          changeSummary[prop] = Change(oldValue !== newValue);
        }
        if (newProp.required && newProp.validationMessage) {
          isFormValid = false;
        }
        if (properties[prop].spinner) {
          properties[prop].spinner = "hidden";
        }
      }.bind(this));
      this.logger.debug("Got 'validate'. Is form valid? " + (isFormValid ? "yes" : "NO"));
      this.setFormValid(isFormValid);
      this.initialLoad = false;
      this.capabilityController.updateRefs(changeSummary);
    }
  },
  handleOauthReturn: function handleOauthReturn(event) {
    //TODO call capability controller
    // Remove the auth URI. This basically restarts the auth flow from scratch on the next
    // render pass.
    analytics.track("auth.oauth.end", {
      label: this.getServiceId()
    });
    delete this.capabilityController.authorizationURI;
    event.source.postMessage({
      request: "close"
    }, event.origin);
    this.logger.debug("Got 'oauth-return'.");
    this.scheduleWork("populate");
  },
  // Iff the model has changed since the given message was sent, returns how
  // stale the response is in ms. Otherwise returns 0
  getResponseStaleness: function getResponseStaleness(data) {
    var timestamp = data.__lastTimestamp || (data.body ? data.body.__lastTimestamp : undefined);
    var lastModification = this.getLastModification(this);
    if (typeof timestamp === "number" && lastModification > timestamp) {
      return lastModification - timestamp;
    }
    return 0;
  },
  scheduleWork: function scheduleWork(type) {
    this.onScheduleWork(type, [{
      capability: this.capability,
      changeSummary: null
    }]);
  },
  // returns id of the associated capability
  getServiceId: function getServiceId() {
    return this.capability.capabilityId || this.capability.service_id || this.capability["service-category"];
  },
  // kick off the fun
  start: function start() {
    this.authenticate();
    this.capabilityController.onValidatorEvent("load", {
      type: "end",
      source: this
    });
  }
};
function isErrorStatusCode(value) {
  return typeof value === "number" && 400 <= value && value <= 599;
}
function isErrorResponse(xhrResult) {
  if (xhrResult.xhr && xhrResult.xhr.status === 401) {
    // 401 is not an error, it's reserved for auth flow
    return false;
  }
  return isErrorStatusCode(xhrResult.xhr ? xhrResult.xhr.status : null) || xhrResult instanceof Error;
}
function isUnauthorizedResponse(xhrResult) {
  // when in 'authorized' flow then 401 is not an error, part of the auth flow.
  var unauthorized = !!(xhrResult.xhr && xhrResult.xhr.status === 401);
  return unauthorized;
}
function Change(valueChanged) {
  return {
    source: "validator",
    valueChanged: valueChanged
  };
}
function valueOf(prop) {
  return prop.value;
}
var Validator = /*#__PURE__*/function (_React$Component) {
  function Validator(props) {
    var _this2;
    _classCallCheck(this, Validator);
    _this2 = _callSuper(this, Validator, [props]);
    _this2.state = {
      val: new _ValidatorController(_this2.props, _this2)
    };
    return _this2;
  }
  _inherits(Validator, _React$Component);
  return _createClass(Validator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var ctrl = this.state.val;
      this.listener = ctrl.handlePostMessage.bind(ctrl);
      window.addEventListener("message", this.listener);
      ctrl.start();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("message", this.listener);
      this.state.val.capabilityController.onValidatorEvent("unload", {
        source: this.state.val
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: "iFrame",
        className: "formValidator",
        "data-src": this.state.val.formValidator
      });
    }
  }]);
}(React.Component);
export { Validator as default };